import React from 'react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useBreakpointValue,
} from '@chakra-ui/react';

interface DialogProps {
  title?: string;
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  footerActions?: React.ReactNode;
}

const Dialog: React.FC<DialogProps> = ({
  title,
  isOpen,
  onClose,
  children,
  footerActions,
}) => {
  const modalSize = useBreakpointValue({ base: 'sm', md: 'md' });
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={modalSize} isCentered>
      <ModalOverlay 
        bg="rgba(0, 0, 0, 0.4)" 
        backdropFilter="blur(6px)" 
      />
      <ModalContent >
        <ModalHeader color="brand.fontColors.primary" pr="12">{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody color="brand.fontColors.primary">{children}</ModalBody>
        <ModalFooter>
          {footerActions}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default Dialog;
